import React from 'react'
import { Field, formValueSelector, change } from 'redux-form'
import { connect } from 'react-redux'
import { throttle, debounce, chunk, filter } from 'lodash'

import { utils } from 'alelo-logic'
import { gqlQuery } from 'alelo-logic/services/common/apolloClient'
import {
  getPlateFilters,
  addPlateFilter,
  updatePlateFilter,
  deletePlateFilter
} from 'alelo-logic/services/dashboardService'
import { gqlIdentificadoresPaginado } from 'alelo-logic/services/queries/vehicles'
import {
  Container,
  InputContainer,
  SearchInput,
  SearchInputWrapper,
  Error,
  Loading,
  SearchIconContainer,
  Content,
  Title,
  CloseIconContainer,
  FilterContainer,
  SaveFilterSelection
} from './styles'
import imgLoading from '../../../../static/loading.gif'
import SearchIcon from '../../../elements/Icons/SearchIcon'
import IcClose from '../../../elements/Icon/ic-close'
import IcEdit from '../../../elements/Icon/ic-edit'
import IdentifierTable from './IdentifierTable'
import IdentifierPaginator from './IdentifierPaginator'

import { darkSlateBlue } from '../../../../styles/settings/colors'
import { noSpecialCharacters } from '../../../../utils/masks'
import SelectPlateFilterSelection from './SelectPlateFilterSelection'
import CreateEditFilterSelectionModal from './CreateEditFilterSelectionModal'

export const renderSelectFilterField = props => (
  <Select
    {...props.input}
    label={props.label}
    onChange={value => props.input.onChange(value)}
    options={props.options}
    errorMessage={props.meta.touched && props.meta.error}
    isRequired={props.isRequired}
    placeholder={props.placeholder}
    negative={props.negative}
    disabled={props.disabled}
  />
)

const renderSearchInput = props => {
  return (
    <SearchInputWrapper hide={props.hide}>
      <SearchIconContainer>
        <SearchIcon />
      </SearchIconContainer>
      {props.input.value.length > 0 &&
        !props.isLoading && (
          <CloseIconContainer onClick={() => props.resetInput()}>
            <IcClose width="22" height="22" fill={darkSlateBlue} />
          </CloseIconContainer>
        )}
      <SearchInput
        {...props.input}
        value={noSpecialCharacters(props.input.value)}
        type="text"
        placeholder={props.placeholder}
      />
      {props.loading && <Loading src={imgLoading} />}
      {props.meta.error && <Error>{props.meta.error}</Error>}
    </SearchInputWrapper>
  )
}

const throttledGqlQuery = throttle(gqlQuery, 2000)

function fixedGqlParams(accountId) {
  return {
    idConta: accountId,
    quantidade: 24,
    ordenacao: 'placa',
    somentePlacas: true
  }
}

class FilterByIdentifier extends React.Component {
  state = {
    openModal: false,
    editFilter: null,
    modalType: 'CREATE',
    showEditSelectionBlock: false,
    editingSelection: false,
    currentOption: null,
    isLoading: false,
    isLoadingPagination: false,
    identificadores: [],
    requestPaginationTotal: 0,
    total: 0,
    paginaAtual: 1,
    previousSearch: '',
    options: []
  }

  changeOption = async optionSelected => {
    if (optionSelected.id === 'TODAS') {
      const { requestPaginationTotal } = this.state
      this.setState({
        currentOption: optionSelected,
        total: requestPaginationTotal,
        paginaAtual: 1,
        showEditSelectionBlock: false
      })
      this.props.dispatch(change('statementsFilter', 'placas', []))
    } else {
      this.setState({
        paginaAtual: 1,
        currentOption: optionSelected,
        showEditSelectionBlock: true
      })
      this.props.dispatch(change('statementsFilter', 'placas', optionSelected.info))
    }
  }

  changePage = async page => {
    const { selectedIdentifiers } = this.props
    const { editingSelection, currentOption } = this.state
    if (
      selectedIdentifiers &&
      selectedIdentifiers.length > 0 &&
      currentOption &&
      currentOption.id !== 'TODAS' &&
      !editingSelection
    ) {
      this.setState({
        paginaAtual: page
      })
    } else {
      this.setState({ isLoadingPagination: true })
      const response = await throttledGqlQuery(gqlIdentificadoresPaginado, {
        placa: this.props.searchInputValue,
        pagina: page,
        ...fixedGqlParams(this.props.accountId)
      })
      if (response.data.identificadoresPJV2.identificadores.length) {
        this.setState({
          isLoadingPagination: false,
          identificadores: response.data.identificadoresPJV2.identificadores,
          paginaAtual: page
        })
      }
    }
  }

  getFilteredSelectedIdentifiers = value => {
    if (!value) {
      return this.state.currentOption.info
    } else {
      const filteredIdentifiers = filter(this.state.currentOption.info, i => {
        return (
          i.placa.toLocaleLowerCase().indexOf(value) >= 0 ||
          i.placa.toLocaleLowerCase().indexOf(value) >= 0
        )
      })
      return filteredIdentifiers
    }
  }

  changeInput = debounce(async value => {
    if ((value.length > 2 || value.length === 0) && value !== this.state.previousSearch) {
      if (this.state.currentOption && this.state.currentOption.id !== 'TODAS') {
        const { selectedIdentifiers } = this.props
        const filteredIdentifiers = this.getFilteredSelectedIdentifiers(value)

        this.setState({
          isLoading: false,
          previousSearch: value,
          total:
            filteredIdentifiers.length > 0
              ? filteredIdentifiers.length
              : selectedIdentifiers.length,
          paginaAtual: 1
        })

        this.props.dispatch(change('statementsFilter', 'placas', filteredIdentifiers))
      } else {
        this.setState({ isLoading: true })
        const response = await gqlQuery(gqlIdentificadoresPaginado, {
          placa: value,
          ...fixedGqlParams(this.props.accountId)
        })
        const { identificadores, paginacao } = response.data.identificadoresPJV2
        this.setState({ isLoading: false, previousSearch: value })
        this.setState({ identificadores: identificadores, total: paginacao.total, paginaAtual: 1 })
      }
    }
  }, 1000)

  resetInput = async () => {
    this.setState({ paginaAtual: 1 })
    this.props.dispatch(change('statementsFilter', 'searchPlate', ''))
    if (this.state.showEditSelectionBlock) {
      this.props.dispatch(change('statementsFilter', 'placas', this.state.currentOption.info))
    }
  }

  async componentDidMount() {
    this.setState({ isLoading: true })
    const filtrosPlacas = await getPlateFilters(this.props.accountId, 'PLACAS')

    const response = await gqlQuery(gqlIdentificadoresPaginado, {
      ...fixedGqlParams(this.props.accountId)
    })
    const { identificadores, paginacao } = response.data.identificadoresPJV2
    this.setState({
      identificadores: identificadores,
      requestPaginationTotal: paginacao.total,
      total: paginacao.total,
      isLoading: false,
      options: filtrosPlacas.data.map(filtro => ({
        ...filtro,
        info: filtro.info.map(info => ({ placa: info.placa }))
      }))
    })
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.selectedIdentifiers && this.props.selectedIdentifiers === undefined) {
      this.setState({
        currentOption: null,
        showEditSelectionBlock: false
      })
    }
    if (prevProps.searchInputValue && this.props.searchInputValue === undefined) {
      if (this.state.currentOption && this.state.currentOption.id !== 'TODAS') {
        this.props.dispatch(change('statementsFilter', 'placas', this.state.currentOption.info))
      } else {
        this.setState({ isLoading: true })
        const response = await gqlQuery(gqlIdentificadoresPaginado, {
          ...fixedGqlParams(this.props.accountId)
        })
        const { identificadores, paginacao } = response.data.identificadoresPJV2
        this.setState({
          identificadores,
          requestPaginationTotal: paginacao.total,
          total: paginacao.total,
          isLoading: false
        })
      }
    }
  }

  plateValidation = value => {
    if (value && value.length >= 7) {
      return utils.plateValidate(value)
    }
    return undefined
  }

  toggleModal = (modalType = 'CREATE', editFilter = null) => {
    this.setState({
      openModal: !this.state.openModal,
      modalType,
      editFilter
    })
  }

  onCancelEditSelection = () => {
    this.props.dispatch(change('statementsFilter', 'placas', this.state.currentOption.info))
    this.setState({
      showEditSelectionBlock: !this.state.showEditSelectionBlock,
      editingSelection: !this.state.editingSelection
    })
  }

  createPlateFilter = async filterName => {
    const { selectedIdentifiers } = this.props

    const result = await addPlateFilter({
      conta: this.props.accountId,
      descricaoFiltro: filterName,
      info: selectedIdentifiers,
      tipo: 'PLACAS'
    })

    if (result.data) {
      this.setState({
        options: [
          ...this.state.options,
          {
            id: result.data.id,
            descricaoFiltro: filterName,
            info: selectedIdentifiers
          }
        ],
        currentOption: {
          id: result.data.id,
          descricaoFiltro: filterName,
          info: selectedIdentifiers
        },
        showEditSelectionBlock: true
      })
    }
  }

  editPlateFilter = async filterName => {
    const { currentOption } = this.state
    const { selectedIdentifiers } = this.props
    const result = await updatePlateFilter({
      id: currentOption.id,
      conta: this.props.accountId,
      descricaoFiltro: filterName,
      info: selectedIdentifiers.map(selected => ({ placa: selected.placa })),
      tipo: 'PLACAS'
    })

    if (result.data) {
      const optionIndex = this.state.options.findIndex(option => option.id === result.data.id)
      let newData = this.state.options
      newData[optionIndex] = result.data
      this.setState({
        currentOption: { ...result.data, info: result.data.info.map(i => ({ placa: i.placa })) },
        options: newData,
        showEditSelectionBlock: true,
        editingSelection: false
      })
    }
  }

  deletePlateFilter = async id => {
    const result = await deletePlateFilter(this.props.accountId, id)

    if (result && result.data && result.data.msg.includes('sucesso')) {
      const newData = this.state.options.filter(option => option.id !== id)
      this.setState({
        options: newData
      })
    }
  }

  renderCreateEditSelection = () => {
    const { currentOption, showEditSelectionBlock, editingSelection } = this.state
    const { selectedIdentifiers } = this.props

    if (showEditSelectionBlock && currentOption) {
      return (
        <FilterContainer>
          <SaveFilterSelection
            type="button"
            onClick={() =>
              this.setState({
                showEditSelectionBlock: !showEditSelectionBlock,
                editingSelection: true,
                paginaAtual: 1
              })
            }
          >
            Editar seleção
            <IcEdit />
          </SaveFilterSelection>
        </FilterContainer>
      )
    }

    if (currentOption && currentOption.id !== 'TODAS' && editingSelection) {
      return (
        <FilterContainer>
          <SaveFilterSelection secondary type="button" onClick={() => this.onCancelEditSelection()}>
            Cancelar
          </SaveFilterSelection>
          <SaveFilterSelection
            type="button"
            onClick={() => this.toggleModal('EDIT', currentOption)}
          >
            Salvar alterações
            <IcEdit />
          </SaveFilterSelection>
        </FilterContainer>
      )
    } else if (selectedIdentifiers && selectedIdentifiers.length > 0) {
      return (
        <FilterContainer>
          <SaveFilterSelection type="button" onClick={() => this.toggleModal()}>
            Salvar seleção de placas
          </SaveFilterSelection>
        </FilterContainer>
      )
    }
    return null
  }

  render() {
    const {
      identificadores,
      total,
      paginaAtual,
      isLoading,
      isLoadingPagination,
      currentOption,
      options,
      openModal,
      editFilter,
      modalType,
      showEditSelectionBlock,
      editingSelection
    } = this.state

    const { selectedIdentifiers } = this.props

    const identificadoresOrderDesc =
      identificadores.length > 0
        ? identificadores.sort((a, b) => a.veiculo.placa.localeCompare(b.veiculo.placa))
        : identificadores

    const selectedIdentifiersChunk =
      selectedIdentifiers && selectedIdentifiers.length > 0
        ? chunk(selectedIdentifiers.sort((a, b) => a.placa.localeCompare(b.placa)), 24)
        : [[]]

    const totalItems =
      selectedIdentifiers &&
      selectedIdentifiers.length > 0 &&
      currentOption &&
      currentOption.id !== 'TODAS' &&
      !editingSelection
        ? selectedIdentifiers.length
        : total

    return (
      <Container>
        <Content>
          <Title>Placa</Title>

          <InputContainer>
            <Field
              component={renderSearchInput}
              onChange={e => this.changeInput(noSpecialCharacters(e.target.value))}
              name="searchPlate"
              validate={this.plateValidation}
              placeholder="Busque por placa"
              loading={isLoading}
              resetInput={this.resetInput}
              isLoading={isLoading}
            />
            <SelectPlateFilterSelection
              currentOption={currentOption}
              setOption={this.changeOption}
              onDelete={item => this.toggleModal('DELETE', item)}
              options={options}
              editingSelection={editingSelection}
              showEditSelectionBlock={showEditSelectionBlock}
              editingNewSelectionLength={selectedIdentifiers && selectedIdentifiers.length}
            />
          </InputContainer>

          <IdentifierTable
            editSelectionBlock={showEditSelectionBlock}
            editingSelection={editingSelection}
            isLoadingPagination={isLoadingPagination}
            identificadores={identificadoresOrderDesc}
            selectedIdentifiers={
              selectedIdentifiersChunk &&
              !editingSelection &&
              currentOption &&
              currentOption.id !== 'TODAS'
                ? selectedIdentifiersChunk[paginaAtual - 1]
                : selectedIdentifiers
            }
          />
          <IdentifierPaginator
            total={totalItems}
            paginaAtual={paginaAtual}
            changePage={this.changePage}
          />
          {this.renderCreateEditSelection()}
        </Content>
        {openModal && (
          <CreateEditFilterSelectionModal
            onCreate={filterName => this.createPlateFilter(filterName)}
            onEdit={filterName => this.editPlateFilter(filterName)}
            onDelete={id => this.deletePlateFilter(id)}
            modalType={modalType}
            editFilter={editFilter}
            isOpen={openModal}
            toggleModal={this.toggleModal}
          />
        )}
      </Container>
    )
  }
}

const selector = formValueSelector('statementsFilter')
const mapStateToProps = state => ({
  searchInputValue: selector(state, 'searchPlate'),
  selectedIdentifiers: selector(state, 'placas')
})

export default connect(mapStateToProps)(FilterByIdentifier)



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatement/FilterByIdentifier/FilterByIdentifier.js